import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Paper } from '@mui/material';
import ActionWithConfirmation from '../components/ActionWithConfirmation';
import apiClient from '../config/axios';

// Funzione per generare dati casuali
function randomString(length) {
  const chars = 'abcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

const columns = [
  { field: 'id', headerName: 'ID', flex: 1,
    minWidth: 150, resizable: true,
  },
  { field: 'name', headerName: 'Nome', flex: 1,
    minWidth: 150, resizable: true,
  },
  { field: 'surname', headerName: 'Cognome', flex: 1,
    minWidth: 150, resizable: true,
  },
  { field: 'age', headerName: 'Età', type: 'number', flex: 1,
    minWidth: 150, resizable: true,
  },
  { field: 'city', headerName: 'Città', flex: 1,
    minWidth: 150, resizable: true,
  },
];

const rows = Array.from({ length: 200 }, (_, i) => ({
  id: i + 1,
  name: randomString(6),
  surname: randomString(8),
  age: Math.floor(Math.random() * 60) + 18,
  city: randomString(5),
}));

export default function TestDataGrid() {
  const [wallData, setWallData] = useState(null);

  const handleGetWall = async () => {
    const response = await apiClient.get(`/api/walls`);
    setWallData(response.data);
    console.log(response.data);
    return {
      message: `Walls caricati con successo!`,
      severity: 'success'
    };
  };

  return (
    <div style={{ width: '100%', padding: 32 }}>
      <h2>Test DataGrid (200 record random)</h2>
      
      <Box sx={{ marginBottom: 2 }}>
        <ActionWithConfirmation
          confirmTitle="Conferma Caricamento"
          confirmMessage="Sei sicuro di voler caricare i dati del wall?"
          onAction={handleGetWall}
          onSuccess={(result) => {
            console.log('Wall caricato:', result);
          }}
          variant="contained"
          color="primary"
        >
          Carica Wall
        </ActionWithConfirmation>
      </Box>

      {wallData && (
        <Box sx={{ marginBottom: 2 }}>
          <Paper elevation={2} sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
            <Typography variant="h6" gutterBottom>
              Dati Wall Caricati:
            </Typography>
            <Box component="pre" sx={{ 
              backgroundColor: '#fff', 
              p: 2, 
              borderRadius: 1, 
              overflow: 'auto',
              fontSize: '0.875rem',
              fontFamily: 'monospace'
            }}>
              {JSON.stringify(wallData, null, 2)}
            </Box>
          </Paper>
        </Box>
      )}

      <DataGrid
        rows={rows}
        columns={columns}
        hideFooterPagination={rows.length <= 25}
      />
    </div>
  );
} 